module.exports = __webpack_public_path__ + "a119bab33aa5b3c59847f09440b72705.svg";